/*var Kickstarter = $('#kickstarter_progress').data('project');
var deadline = new Date(Kickstarter.deadline*1000);
var elem = $('#kickstarter_progress');

elem.append('<h3>Goal: ' + Kickstarter.goal + '</h3>');
console.log(Kickstarter);*/